import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Banner from '@src/components/Banner';
import { isGrounds } from '@src/utils/app';
import MainSwiper from './MainSwiper';
import Header from './header';
import List from './list';
import Bottom from '@src/components/bottom';
import CallApp from '@src/components/callApp';
import { pageHandler } from '@src/utils';

pageHandler('entMoveIndex');
const Layout = ({ content }) => {
    console.log(content);
    const { mainSwiper, listData } = content;
    const docWidth = Math.min(window?.__IFENG_ENV__?.maxDocWidth || 812, window.innerWidth);
    const offsetSize = 140 * docWidth / 750;

    return (
        <>
            <CallApp />
            <div className={styles.layout} style={isGrounds ? {} : { backgroundPosition: `0 -${offsetSize}px` }}>
                <Banner
                    shareTitle="凤凰网院线经理指数"
                    shareDesc="全国多位一线电影院线工作者预测市场走势，为行业提供真实、新鲜、有价值的参考数据。"
                    shareThumbnail="https://x0.ifengimg.com/fe/custom/2024_08_05/shareimg.99aed0ce700b.jpg"
                />
                <MainSwiper content={mainSwiper} />
                <Header />
                <List list={listData} />
                <Bottom />
            </div>
        </>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
